// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SpamProtectionController from "./spam_protection_controller"
application.register("spam-protection", SpamProtectionController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import ToggleCcController from "./toggle_cc_controller"
application.register("toggle-cc", ToggleCcController)
